import React, { Component, PropTypes } from 'react';

class ArrowBox extends Component {

  render() {
    return (
      <div style={this.props.boxStyle} className={this.props.blueArrowColor ? ' arrow-box blue-arrow-box' : 'arrow-box'}>
        <div style={this.props.innerBoxStyle} className="arrow-box-inner">
          {this.props.children}
        </div>
      </div>
    );
  }
}

ArrowBox.propTypes = {
  boxStyle: PropTypes.object,
  innerBoxStyle: PropTypes.object,
  children: PropTypes.any,
  blueArrowColor: PropTypes.bool,
};

export default ArrowBox;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/arrow-box.jsx